export default __webpack_public_path__ + "static/SPX-b5f245d065a5b8906f23c2ba106a329b.png";